module.exports = __webpack_public_path__ + "static/media/iron.967efa68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iron.png
// module id = 1057
// module chunks = 0